export enum IntegrationType {
    Apricot = 'Apricot',
    ETO = 'ETO',
    NONE = 'none'
}
